export default __webpack_public_path__ + "static/media/shopify-img.5a557dd3.png";